module.exports = __webpack_public_path__ + "static/img/certificate_img20.6b26ef3d.jpg";